import { selectAgentLevelInfo } from './selectAgentLevelInfo';
import { IState } from '../../store';

export const selectIsHonestIconsShow = (state: IState): boolean => {
  const agentLevelInfo = selectAgentLevelInfo(state);

  if (!agentLevelInfo) {
    return false;
  }

  const { levelName, levelOrder } = agentLevelInfo;

  return Boolean(levelName && levelOrder && levelOrder > 2);
};
